import * as yup from 'yup';



  export const managerValidationSchema = yup.object().shape({
      userId: yup.number().required("Il manager è richiesto.").typeError("Il manager è richiesto."),
      name: yup.string().required("Il manager è richiesto."),
      imageProfileUrl: yup.string()
  });
  